import React, { useContext, useRef, useLayoutEffect } from 'react';

import setFullscreenVideoAspectRatio from '../helpers/VideoHelper';
import CustomSelect from '../components/CustomSelect';

import bgVideo from './../assets/videos/kruin_bg.mp4';
import { MainContext } from '../components/MainLayoutWrapper';

function PageVakcurriculum() {
    const mainContext = useContext(MainContext)
    const videoEl = useRef(null);

    function resize() {
        if (videoEl.current === null) return;
        setFullscreenVideoAspectRatio(videoEl.current, 16 / 9);
    }
    resize();

    useLayoutEffect(() => {
        if (videoEl.current === null) return;

        resize();
        window.addEventListener('resize', resize);

        return () => window.removeEventListener('resize', resize);
    }, []);

    function goToSelectedKlas() {
        const slug = mainContext.activeFilters.klas === null
            ? mainContext.klassen[0].slug
            : mainContext.activeFilters.klas;

        if (mainContext.activeFilters.klas === null) { // Only happens the first time. We need this to prevent showing the default placeholder in the selectbox
            mainContext.helperFunctions.setKlasFilter(slug);
        }

        // Reset vak and traject filters
        mainContext.helperFunctions.setVakFilter(null);
        mainContext.helperFunctions.setTrajectFilter(null);

        mainContext.helperFunctions.nav(`/vakcurriculum/klas/${slug}`);
    }

    return (<>
        {!!mainContext.klassen.length && <>
            <div className="page-start">
                <div className="page-start__main-wrapper">
                    <h1 className="page-start__title">{mainContext.startPage.title}</h1>
                    <div className="page-start__desc default-styles"><p>{mainContext.startPage.description}</p></div>

                    {!!mainContext.klassen.length &&
                        <div className="page-start__grade-select">
                            <span>Ontdek de</span>
                            <CustomSelect placeholderText="Kies een klas" options={mainContext.klassen.map(klas => { return { title: klas.human_name, slug: klas.slug } })} selectedOptionSlug={mainContext.activeFilters.klas !== null ? mainContext.activeFilters.klas : mainContext.klassen[0].slug} setSelectedOptionSlug={mainContext.helperFunctions.setKlasFilter} btnClasses="btn--mustard" compact={true} />
                            <button className="custom-select__go-btn arrow-btn" onClick={() => goToSelectedKlas()}>Ga!</button>
                        </div>
                    }
                </div>

                <div className="page-start__bg-wrapper">
                    <video ref={videoEl} src={bgVideo} type="video/mp4" autoPlay playsInline loop muted></video>
                </div>
            </div>
        </>}

        {mainContext.klassen.length === 0 && <div className="loading-msg">Laden..</div>}
    </>);
}

export default PageVakcurriculum;